import { createPrecompiledValidator } from "@rjsf/validator-ajv8";

export const getPrecompiledValidator = async (documentId, schemaPrecompiledValidatorUrl, schema) => {
  if (documentId && Object.keys(schema).length > 0) {
    const url = window.location.origin + schemaPrecompiledValidatorUrl.replace("__ID__", documentId);
    const validateFunctions = await import(url);
    return createPrecompiledValidator(validateFunctions, schema);
  }
};
